import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  TimeScale
);

// 🔹 generate date range
const generateDateRange = (days) => {
  const labels = [];
  const dates = [];
  const today = new Date();

  for (let i = days-1; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);

    labels.push(d.toISOString().split("T")[0]);
    dates.push(d);
  }

  return { labels, dates };
};

// 🔹 count enrollments per day
const countEnrollmentsByDate = (data, dates) => {
  return dates.map((date) => {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);

    const end = new Date(date);
    end.setHours(23, 59, 59, 999);

    return data.filter((item) => {
      const created = new Date(item.createdAt);
      return created >= start && created <= end;
    }).length;
  });
};

const generateMonthRange = (year, month) => {
  const labels = [];
  const dates = [];

  const daysInMonth = new Date(year, month, 0).getDate();

  for (let day = 1; day <= daysInMonth; day++) {
    const d = new Date(year, month - 1, day);
    labels.push(d.toISOString().split("T")[0]);
    dates.push(d);
  }

  return { labels, dates };
};

const FarmTrainingChart = ({
  farmTrainingGraphData,
  farmTrainingFrom,
  selectedMonth,
  selectedYear,
}) => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    if (!farmTrainingGraphData?.length) return;

    let filteredData = farmTrainingGraphData;

    // ✅ FILTER BY YEAR FIRST (always applied)
    if (selectedYear) {
      filteredData = filteredData.filter((item) => {
        const year = new Date(item.createdAt).getFullYear();
        return year === Number(selectedYear);
      });
    }

    // ✅ FILTER BY MONTH (priority over days)
    if (selectedMonth) {
      filteredData = filteredData.filter((item) => {
        const month = new Date(item.createdAt).getMonth() + 1;
        return month === Number(selectedMonth);
      });
    } else {
      const fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - farmTrainingFrom);

      filteredData = filteredData.filter(
        (item) => new Date(item.createdAt) >= fromDate
      );
    }
    let labels = [];
    let dates = [];
    
    if (selectedMonth && selectedYear) {
      // ✅ Month view
      const range = generateMonthRange(
        Number(selectedYear),
        Number(selectedMonth)
      );
      labels = range.labels;
      dates = range.dates;
    } else {
      // ✅ Last N days view (MATCHES FILTER)
      const range = generateDateRange(farmTrainingFrom);
      labels = range.labels;
      dates = range.dates;
    }

    const counts = countEnrollmentsByDate(filteredData, dates);

    setChartData({
      labels,
      datasets: [
        {
          label: "Farm Training Enrollments",
          data: counts,
          borderColor: "rgba(75,192,192,1)",
          borderWidth: 1,
          tension: 0.5,
          fill: false,
        },
      ],
    });
  }, [farmTrainingGraphData, farmTrainingFrom, selectedMonth, selectedYear]);

  const options = {
    responsive: true,
    plugins: {
      legend: { display: true },
    },
    scales: {
      x: {
        type: "time",
        time: { unit: "day" },
      },
      y: {
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default FarmTrainingChart;
